enum AdaRestriction {
  left = 'left',
  right = 'right',
  eitherEnd = 'eitherEnd',
}

export default AdaRestriction;
